import {
  MARKETO_BASE_URL,
  MARKETO_FORM_ID,
  MARKETO_MUNCHKIN_ID,
} from '@webapp/infrastructure/envs'
import { MarketoServiceError } from './errors'
import { MarketoService } from './Marketo.service'

const marketoService = new MarketoService({
  baseUrl: MARKETO_BASE_URL,
  munchkinId: MARKETO_MUNCHKIN_ID,
  formId: MARKETO_FORM_ID,
})

export { marketoService, MarketoService, MarketoServiceError }
export {
  FeatureExpansionRequestTypes,
  type FeatureExpansionRequestType,
} from './types'
export type * from './types'
